// Types and interfaces for ModelDataSampleList component

import React from 'react';

// Define column configuration interface
export interface ColumnConfig {
    id: string;
    label: string;
    width: ColumnWidth;
    align: 'left' | 'right' | 'center';
    format: (value: any, row: any) => React.ReactNode;
    sortable?: boolean;
}

// Define column width presets
export interface ColumnWidth {
    minWidth: number;
    maxWidth: number;
}

// Define column width constants
export const COLUMN_WIDTHS = {
    row: { minWidth: 60, maxWidth: 80 },
    status: { minWidth: 100, maxWidth: 120 },
    comment: { minWidth: 80, maxWidth: 100 },
    temperature: { minWidth: 150, maxWidth: 180 },
    flowrate: { minWidth: 150, maxWidth: 180 },
    pressure: { minWidth: 150, maxWidth: 180 },
    default: { minWidth: 150, maxWidth: 180 }
};

// Props interface for ModelDataSampleList component
export interface ModelDataSampleListProps {}

// Filter state interface for tracking filter values
export interface FilterState {
    fromHotMediaFlowRate: string;
    toHotMediaFlowRate: string;
    fromHotMediaTempIn: string;
    toHotMediaTempIn: string;
    fromHotMediaTempOut: string;
    toHotMediaTempOut: string;
    fromHotMediaPressureDrop: string;
    toHotMediaPressureDrop: string;
    
    fromColdMediaFlowRate: string;
    toColdMediaFlowRate: string;
    fromColdMediaTempIn: string;
    toColdMediaTempIn: string;
    fromColdMediaTempOut: string;
    toColdMediaTempOut: string;
    fromColdMediaPressureDrop: string;
    toColdMediaPressureDrop: string;
    
    onlyTodo: boolean;
}

// State interface for the component
export interface ModelDataSampleListState {
    isLoading: boolean;
    pageCount: number;
    currentData: any[];
    currentFilter: string;
    currentPage: number;
    dataColumns: ColumnConfig[];
    configurations: any[];
    showFilters: boolean;
    rowsPerPage: number;
    filterValue: string;
    filterColumn: string;
    orderBy: string;
    order: 'asc' | 'desc';
    columnMenuAnchor: null | HTMLElement;
    activeColumn: string;
    hiddenColumns: string[];
    columnManagerOpen: boolean;
}

// Filter options interface
export interface FilterOptions {
    column: string;
    value: string;
}

// Sort options interface
export interface SortOptions {
    columnId: string;
    direction: 'asc' | 'desc' | null;
} 